
import { australianLocations } from "@/components/company/CompanyFormSchema";

/**
 * Validates a location against the list of Australian locations
 * @param location Location string to validate
 * @returns Boolean indicating if the location is valid
 */
export const isValidAustralianLocation = (location: string): boolean => {
  return australianLocations.includes(location);
};

/**
 * Gets a standardized location or returns the original if not found
 * @param location Location string to standardize
 * @returns Standardized location string
 */
export const getStandardizedLocation = (location: string): string => {
  // If the location is already in the correct format, return it
  if (isValidAustralianLocation(location)) {
    return location;
  }

  // Check if the location partially matches any of the Australian locations
  const matchingLocation = australianLocations.find(
    (ausLocation) => ausLocation.toLowerCase().includes(location.toLowerCase())
  );

  return matchingLocation || location;
};
